module.exports = __webpack_public_path__ + "static/media/klasa_3.c2aada76.svg";